import { BlockchainTimeline } from './components/BlockchainTimeline';
import './App.css';

function App() {
  return <BlockchainTimeline />;
}

export default App;
